import "./CalendarEndRowComponent.scss";

const CalendarEndRowComponent = () => {
  return <div className="calendarRowClosingComponent" />;
};

export default CalendarEndRowComponent;
